import React, { useEffect } from 'react'
import useMediaHandle from '../../../../../../../hooks/useMediaHandle'
import { CircularProgress, useTheme } from '@mui/material'

interface TaskAudioFileProps {
  file: Media
  classes: any
}
const TaskAudioFile: React.FC<TaskAudioFileProps> = ({ file, classes }) => {
  const theme = useTheme()

  const mediaHandle = useMediaHandle({ media: file })
  const { srcURL, loading, startLoad } = mediaHandle

  useEffect(() => {
    if (!srcURL) {
      startLoad()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [srcURL])

  if (loading)
    return (
      <CircularProgress style={{ marginLeft: 'auto' }} size={theme.size.lg} />
    )

  return <audio className={classes.audio} controls src={srcURL} />
}

export default React.memo(TaskAudioFile)
